"use client";

import type { SquashTemplateData } from "../squash-template";
import { ActivityCourtPreview } from "./activity-court-preview";

type SquashDisplayPreviewProps = {
  data: SquashTemplateData | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function SquashDisplayPreview({
  data,
  participants,
}: SquashDisplayPreviewProps) {
  if (!data) {
    return (
      <ActivityCourtPreview
        activityId="squash"
        mode="singles"
        yourTeam={[]}
        opponentTeam={[]}
      />
    );
  }

  const yourTeam = participants
    .filter((p) => data.positions[p.id] === "your-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));
  const opponentTeam = participants
    .filter((p) => data.positions[p.id] === "opponent-team")
    .map((p) => ({ ...p, handle: p.username ?? undefined }));

  const showScore = data.hasScore !== false;
  const yourWon = data.matchScore.yourGames > data.matchScore.opponentGames;

  return (
    <div>
      <ActivityCourtPreview
        activityId="squash"
        data={data}
        mode="singles"
        yourTeam={yourTeam}
        opponentTeam={opponentTeam}
        yourWon={showScore ? yourWon : undefined}
        showLabels={false}
        linkToProfiles
      />
    </div>
  );
}
